export default __webpack_public_path__ + "static/media/miniatureLogo.40fc195b.svg";